import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE } from '@sisyphe/utils'

export default modelExtend(basicModel, {
  namespace: 'order',
  state: {
    orderInfo: {},
    orderSuccessInfo: {},
  },
  reducers: {},
  effects: {
    /** 设置订单信息 */
    *setOrderInfo({ payload }, { call, put }) {
      yield put({
        type: UPDATESTATE,
        payload: {
          orderInfo: payload,
        },
      })
    },
    /** 下单成功 */
    *setOrderSuccessInfo({ payload }, { call, put }) {
      yield put({
        type: UPDATESTATE,
        payload: {
          orderSuccessInfo: payload,
        },
      })
    },
  },
})
